import { Head } from "@inertiajs/react";
import TrophiesSection, {
  TrophyCard,
} from "../Home/components/TrophiesSection/TrophiesSection";
import CategoriesSection from "./components/CategoriesSection";
import Hero from "./components/Hero";
import MobileVoteBar from "./components/MobileVoteBar";
import NomineesSection from "./components/NomineesSection";
import { Nominee } from "./types";
import "./styles.css";

type TrophiesShowProps = {
  citadines: Nominee[];
  familiales: Nominee[];
  trophy_cards: TrophyCard[];
};

const TrophiesShow = ({
  citadines,
  familiales,
  trophy_cards,
}: TrophiesShowProps) => {
  return (
    <div className="trophies-page">
      <Head>
        <title>Trophées des Véhicules Électriques 2026 - Review car</title>
        <meta
          name="description"
          content="Votez pour la meilleure citadine et la meilleure familiale électrique 2026. Votes ouverts jusqu'au 30 septembre 2026."
        />
      </Head>
      <Hero nomineesCount={citadines.length + familiales.length} />
      <CategoriesSection />
      <TrophiesSection vehicles={trophy_cards} showPalmaresLink={false} />
      <NomineesSection citadines={citadines} familiales={familiales} />
      <MobileVoteBar />
    </div>
  );
};

export default TrophiesShow;
